import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { IndentIssueDetails } from './IndentIssueDetails';

export interface IndentIssueHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface IndentIssueHeader { 

    id?:number;
    issueDate:any;
    issueDoneBy:string;
    senderTenantId:string;
    senderBranchId:string;
    senderDepartmentId:string;
    receiverTenantId:string;
    receiverBranchId:string;
    receiverDepartmentId?:string;
    createdBy:string;
    createdDate:any;
    branchId: string;
    tenantId: string; 
    internalDepartmentId:any;
    pharmacyId:any;
    phIndentIssueDetDto: IndentIssueDetails[];
    indentType?: string | null,
    receiverLocationId?: string | null,
    
    parameters?: IndentIssueHeaderParameter[];
    links?: any;
    indentRequestId?:number;
}


export abstract class IndentIssueHeaderData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<IndentIssueHeader[]>;
    abstract create(url: string, data: IndentIssueHeader): Observable<IndentIssueHeader[]>;
    abstract update(url: string, data: IndentIssueHeader): Observable<IndentIssueHeader>;
}
